import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  View,
  Text,
  Dimensions,
  ActivityIndicator,
  Image,
  ScrollView,
  TouchableOpacity,
  Linking,
  StyleSheet,
} from "react-native";
import { colors } from "../common/styles/colors";
import { fonts } from "../common/styles/fonts";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../api/api";
import { Meeting } from "../api/models/Meeting";
import _, { replace } from "lodash";
import { format } from "date-fns";
import { useReferral } from "../utils/useReferral";
import { UserAvatar } from "../components/user-avatar";
import { CommonButton } from "../components/buttons";
import { PinLightYellowIcon } from "../common/icons/PinLightYellowIcon";
import { PriceAndMenuOptions } from "../components/PriceAndMenuOptions";
import { AddToCalendarIcon } from "../common/icons/AddToCalendar";
import { MeetingPlaceIcon } from "../common/icons/MeetingPlace";
import { InvitedContainer } from "../components/InvitedContainer";
import {
  getMeetingPicture,
  usePriceAndMenuOptions,
} from "../utils/use-meeting-data";

export const GadderingPage = () => {
  const { gadderingId } = useParams();

  const [isLoading, setIsLoading] = useState(false);

  const [meeting, setMeeting] = useState<Meeting | null>(null);

  const [error, setError] = useState<any>(null);

  useEffect(() => {
    if (gadderingId) {
      api.meetings
        .getMeeting(gadderingId)
        .then((response) => setMeeting(response.data))
        .catch((error) => {
          setError(error);
          console.log("error", error);
        })
        .finally(() => setIsLoading(false));
    }
  }, [gadderingId]);

  const placeGenerated = useMemo(
    () => meeting && _.isNumber(meeting?.generated_index),
    [meeting]
  );

  const [isDeepLinkLoading, deepLink] = useReferral(meeting?.author?.id);

  const userInvitedList = useMemo(
    () =>
      meeting
        ? [
            ...(meeting.show_for_users || []),
            ...(meeting.votes
              ? meeting.votes
                  .filter((_vote) => !_vote.user?.id)
                  .map((_vote) => ({ isVote: true, nametag: _vote.user_name }))
              : []),
          ]
        : [],
    [meeting]
  );

  const votes = meeting?.votes?.length || 0;

  const totalVotes =
    (meeting?.show_for_users?.length || 1) +
    (meeting?.votes?.filter((_vote) => !_vote.user).length || 0);

  const navigate = useNavigate();

  const placeId =
    placeGenerated && meeting?.places![meeting?.generated_index!].place_id;

  const toPlace = () => {
    navigate(`../place/${placeId}`, { replace: true });
  };

  // @ts-ignore
  const priceAndMenuOptions: string[] = usePriceAndMenuOptions(meeting);

  return (
    <View style={{ flex: 1 }}>
      {isLoading || isDeepLinkLoading || (!meeting && !error) ? (
        <ActivityIndicator
          color={colors.black}
          style={{
            height: Dimensions.get("window").height,
          }}
        />
      ) : error || !meeting ? (
        <View
          style={{
            height: Dimensions.get("window").height,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: colors.LightGrayishYellow,
          }}
        >
          <Text style={[fonts.largeText_bold, { color: colors.black }]}>
            Error
          </Text>
          <Text
            style={[
              fonts.mediumText_medium,
              { color: colors.black, textAlign: "center" },
            ]}
          >
            {error?.message}
          </Text>
        </View>
      ) : (
        <View
          style={{
            height: Dimensions.get("window").height,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View
            style={{
              height: "100%",
              maxWidth: 500,
              width: "100%",
            }}
          >
            <ScrollView
              contentContainerStyle={{
                paddingBottom: 32,
                alignItems: "center",
                display: "flex",
              }}
            >
              <View
                style={{
                  flex: 2,
                  alignSelf: "stretch",
                }}
              >
                <View style={styles.eventImg}>
                  {placeGenerated && meeting.places ? (
                    <Image
                      style={{ flex: 1 }}
                      // @ts-ignore
                      source={{
                        uri: meeting.places[meeting.generated_index!].picture_1,
                      }}
                    />
                  ) : (
                    <Image
                      style={{ width: "100%", height: "100%" }}
                      source={getMeetingPicture(meeting)}
                    />
                  )}
                  <View style={styles.overlay} />
                </View>

                <View style={[styles.upperContainer]}>
                  <Text
                    numberOfLines={1}
                    style={[
                      fonts.largeText_bold,
                      {
                        color: colors.white,
                        marginBottom: 11,
                      },
                    ]}
                  >
                    {meeting?.custom_name ||
                      (meeting.places && _.isNumber(meeting.generated_index)
                        ? meeting.places[meeting.generated_index].name
                        : "") ||
                      meeting?.district ||
                      meeting?.city}
                  </Text>

                  <CommonButton
                    style={{
                      marginBottom: 12,
                      alignSelf: "flex-start",
                      maxWidth: 300,
                    }}
                    type="white"
                    LeftIcon={<PinLightYellowIcon />}
                    textStyle={[fonts.smallText_bold, { marginLeft: 4 }]}
                    containerStyle={styles.smallButton}
                    title={
                      meeting.places && _.isNumber(meeting.generated_index)
                        ? meeting.places[meeting.generated_index].address
                        : "TBD"
                    }
                    size={"small"}
                  />

                  <PriceAndMenuOptions
                    data={priceAndMenuOptions}
                    style={{ marginBottom: 11 }}
                  />
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <UserAvatar
                      user={!!meeting.author ? meeting.author : undefined}
                      size={32}
                      style={{ marginRight: 8 }}
                    />
                    <Text
                      style={[fonts.mediumText_medium, { color: colors.white }]}
                    >
                      {meeting.author?.nametag}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={[styles.bottomContainer]}>
                <CommonButton
                  type="black"
                  size="medium"
                  style={{ marginBottom: 16 }}
                  containerStyle={{
                    paddingVertical: 11,
                    paddingHorizontal: 16,
                  }}
                  textStyle={fonts.smallMediumText_bold}
                  title={
                    meeting.date
                      ? format(
                          new Date(meeting.date),
                          "do 'of' LLL',' E hh:mm aaaaa'm'"
                        )
                      : ""
                  }
                  RightIcon={<AddToCalendarIcon style={{ marginLeft: 8 }} />}
                />

                {placeGenerated && (
                  <CommonButton
                    type="black"
                    size="medium"
                    onPress={toPlace}
                    style={{ marginBottom: 24 }}
                    title={"About this place"}
                    textStyle={fonts.mediumText_bold}
                    containerStyle={{
                      paddingVertical: 3,
                      paddingHorizontal: 3,
                      paddingRight: 16,
                    }}
                    LeftIcon={<MeetingPlaceIcon style={{ marginRight: 8 }} />}
                  />
                )}

                <View style={styles.voteContainer}>
                  <Text
                    style={[fonts.mediumText_bold, { color: colors.black }]}
                  >
                    Invited
                  </Text>
                  <Text
                    style={[
                      fonts.smallMediumText_bold,
                      { color: colors.black },
                    ]}
                  >
                    {placeGenerated
                      ? meeting.show_for_users?.length +
                        (meeting.show_for_users?.length === 1
                          ? " Attendee"
                          : " Attendees")
                      : votes + "/" + totalVotes + " Voted"}
                  </Text>
                </View>
                <InvitedContainer
                  // @ts-ignore
                  invitedUsers={userInvitedList}
                  meeting={meeting}
                  containerStyle={{ marginBottom: 20 }}
                />
              </View>
              <Text
                style={[
                  fonts.mediumText_medium,
                  {
                    color: colors.black,
                    fontWeight: "600",
                    textAlign: "center",
                    marginBottom: 8,
                  },
                ]}
              >
                Discover people and places on the GADDER app
              </Text>

              <View
                style={{
                  paddingHorizontal: 36,
                  alignSelf: "stretch",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <TouchableOpacity
                  onPress={() =>
                    Linking.openURL(
                      deepLink
                        ? String(deepLink)
                        : "https://play.google.com/store/apps/details?id=com.fitme.ball"
                    )
                  }
                >
                  <Image
                    resizeMode={"contain"}
                    style={{ width: 140, height: 50 }}
                    source={require("../common/images/downloadAndroidBlack.png")}
                  />
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() =>
                    Linking.openURL(
                      deepLink
                        ? String(deepLink)
                        : "https://apps.apple.com/gb/app/gadder/id1570036235"
                    )
                  }
                >
                  <Image
                    resizeMode={"contain"}
                    style={{ width: 140, height: 50 }}
                    source={require("../common/images/downloadIosBlack.png")}
                  />
                </TouchableOpacity>
              </View>
            </ScrollView>
          </View>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  eventImg: {
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: 0,
  },
  overlay: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: colors.black,
    opacity: 0.5,
    position: "absolute",
  },
  upperContainer: {
    flex: 1,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 20,
    paddingTop: 38,
    justifyContent: "flex-end",
  },
  bottomContainer: {
    paddingTop: 16,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 24,
    alignItems: "center",
    alignSelf: "stretch",
  },
  smallButton: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    minWidth: 60,
  },
  editButton: {
    position: "absolute",
    right: 16,
    bottom: 12,
  },
  voteContainer: {
    alignSelf: "stretch",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 7,
  },
});
